module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/space-3-medium-04cd9ece497014801ca10b6802b1aba5.jpg";